export const REQUEST_COMPONENTS = 'dt/components/REQUEST_COMPONENTS';
export const RESET_COMPONENTS = 'dt/components/RESET_COMPONENTS';
export const RECEIVE_COMPONENTS = 'dt/components/RECEIVE_COMPONENTS';
export const RECEIVE_STATUS = 'dt/components/RECEIVE_STATUS';
export const CREATE_COMPONENT = 'dt/components/CREATE_COMPONENT';
export const UPSERT_COMPONENTS = 'dt/components/UPSERT_COMPONENTS';
export const CREATE_COMPONENT_SUCCESS = 'dt/components/CREATE_COMPONENT_SUCCESS';
export const DELETE_COMPONENT = 'dt/components/DELETE_COMPONENT';
export const DELETE_NONSITE_COMPONENTS = 'dt/components/DELETE_NONSITE_COMPONENTS';
export const UPDATE_COMPONENT = 'dt/components/UPDATE_COMPONENT';
export const DOWNLOAD_COMPONENTS_TEMPLATE = 'dt/components/DOWNLOAD_COMPONENTS_TEMPLATE';
export const COMPONENT_IMPORT_ERRORS = 'dt/components/COMPONENT_IMPORT_ERRORS';
export const RESET_COMPONENTS_IMPORTED_AT = 'dt/components/RESET_COMPONENTS_IMPORTED_AT';
export const REQUEST_REMOTE_ASSET_INFO = 'dt/components/REQUEST_REMOTE_ASSET_INFO';
export const RECEIVE_REMOTE_ASSET_INFO = 'dt/components/RECEIVE_REMOTE_ASSET_INFO';
export const SET_PAGE_COMPONENTS = 'dt/components/SET_PAGE_COMPONENTS';

export const requestRemoteAssetInfo = (integrationIds, componentId) => ({
  type: REQUEST_REMOTE_ASSET_INFO,
  integrationIds,
  componentId,
});

export const receiveRemoteAssetInfo = (componentId, assetInfo) => ({
  type: RECEIVE_REMOTE_ASSET_INFO,
  componentId,
  assetInfo,
});

export const requestComponents = (siteId) => ({ type: REQUEST_COMPONENTS, siteId });

export const receiveComponents = (...args) => {
  const [components, hashmap, componentTree, siteId, componentsImportedAt = 0] = args;
  return {
    type: RECEIVE_COMPONENTS,
    components,
    hashmap,
    componentTree,
    siteId,
    componentsUpdatedAt: Date.now(),
    componentsImportedAt,
  };
};

export const receiveStatus = (componentsStatus) => ({
  type: RECEIVE_STATUS,
  componentsStatus,
  componentsStatusUpdatedAt: Date.now(),
});

export const resetComponents = () => ({ type: RESET_COMPONENTS });

export const createComponent = (siteId, org, data, doNotify = true) => ({
  type: CREATE_COMPONENT,
  siteId,
  org,
  data,
  doNotify,
});

export const upsertComponents = (siteId, org, components, doNotify = false, update = false) => ({
  type: UPSERT_COMPONENTS,
  siteId,
  org,
  components,
  doNotify,
  update,
});

export const updateComponent = (id, siteId, data, doNotify = true) => ({
  type: UPDATE_COMPONENT,
  id,
  siteId,
  data,
  doNotify,
});

export const deleteComponent = (id, siteId) => ({ type: DELETE_COMPONENT, id, siteId });
export const deleteNonSiteComponents = (org, siteId) => ({
  type: DELETE_NONSITE_COMPONENTS,
  org,
  siteId,
});

export const receiveCreatedComponent = (id, parent) => ({
  type: CREATE_COMPONENT_SUCCESS,
  id,
  parent,
});

export const downloadComponentsExcel = (site) => ({ type: DOWNLOAD_COMPONENTS_TEMPLATE, site });

export const setImportErrors = (errors) => ({ type: COMPONENT_IMPORT_ERRORS, errors });

export const resetImportedComponentsAt = () => ({ type: RESET_COMPONENTS_IMPORTED_AT });

export const setPageComponents = (pageComponents) => ({
  type: SET_PAGE_COMPONENTS,
  pageComponents,
});
